<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
              v-btn(color="error" :disabled="ip.permit.ipVisitorStatus != 16"  style="float: right; margin-right:10px" @click="handleNextPage")
                span Tambah Visitor
          v-divider
          VisitorList(:title='title' :dialogType='dialogType' :dataRequestPermit='dataRequestPermit' :ip='ip' :dataVisitor='dataVisitor' :ipLocation='ipLocation' :ipPenanggungJawab='ipPenanggungJawab')
          
</template>

<script>
import * as config from "../config/index.json";
import PermitModal from "@/components/PermitModal.vue";
import VisitorList from "@/components/VisitorList.vue";
import { mapState } from "vuex";
import helper from "../helper/index.js";
export default {
  name: "MyVisitor",
  components: {
    PermitModal,
    VisitorList
  },
  data () {
    return {
      config: config.default,
      title: 'My Visitor',
      dialogType: 'creator',
      dataVisitor:{},
      ipLocation:[],
      dataRequestPermit:{},
      ipPenanggungJawab:{},
      ip: {
        headers: [
          {
            text: 'Nama Tamu',
            align: 'start',
            value: 'name',
            width: '160px'
          },
          { text: 'Perusahaan', value: 'company',width: '210px' },
          { text: 'Jabatan', value: 'position' },
          { text: 'Email', value: 'email' },
          { text: 'No Handphone', value: 'phone' },
          { text: 'Status', value: 'status',width: '170px' },
          { text: 'Action', value: 'actions' }
        ],
        items: [],
        permit: []
      }, 
      dataPermit :[], 
      dataPermitFilterFrom : [],
      dataPermitFilterStatus : [],     
    }
  },
  computed: {
    ...mapState(["API_URL","listDataVisitor","fetchDataEditRequests","dataEditRequest"])
  },
  mounted () {
    this.$store.dispatch("fetchMyPermit")
    this.$store.dispatch("fetchDataEditRequests", this.$route.params.id);
  },
  methods: {
    formatDate:helper.formatDate,
    handleNextPage(){
      this.$router.push("/add-visitor");
    }
  },
    watch :{
      dataEditRequest(param){
        this.dataVisitor = param
        this.ipLocation = param.ipLocation.map(data =>data.name)
        this.ipPenanggungJawab = param.ipPemegangIzin
        this.ip.items = param.ipVisitors
        this.ip.permit = param;
        this.dataRequestPermit = param
      }
  }
};
</script>
